import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  confirm(event) {
    const message = event.params.message ?? "Are you sure?"
    if (!window.confirm(message)) {
      event.preventDefault()
    }
  }
}
